<h1 mat-dialog-title>General Conditions for Hiring of Equipment</h1>
<div mat-dialog-content>
  <p><strong>1. Definitions and Law</strong></p>
  <p>
    The Contract is the document or documents that set out these conditions and
    all other details about your agreement with us. "We" and "Us" mean the
    supplier of the hired equipment. "You" means the person, firm, company,
    corporation or public authority or body to who we supplier Equipment on
    hire. "Equipment" means the hired items referred to in the contract. These
    Conditions exclude any terms and conditions you may have put forward, except
    where we have agreed to any amendments or other conditions in writing. These
    conditions do not affect the statutory right of a person dealing as consumer
    as defined by the Unfair Contract Terms Act 1977 or any statutory
    modification of them. The contract will be governed by and interpreted in
    accordance with the laws of {{ country }}.
  </p>
  <p><strong>2. Basis of Charging</strong></p>
  <p>
    You will pay the hire charges stated in the Contract. Hire charges will
    begin at the time stated in the contact and will continue during the period
    of the hire until we have given you a collection or off-hire number, or
    until you have restored the equipment to us in a clean and serviceable
    condition and we have given you a receipt for it. All time is chargeable
    including Saturdays, Sundays and Bank Holidays. All charges are payable on
    demand. If payment is not made when due, we will be entitled to interest on
    the amount that is overdue at 5% above the prevailing base rate of Ulster
    Bank Ltd calculated on a daily basis. This will be without prejudice to any
    other rights or remedies we may have. You will also pay to us any charges we
    reasonably incur in the recover from you of money or equipment.
  </p>
  <p><strong>3. Delivery and Carriage Charges</strong></p>
  <p>
    Hire charges do not include carriage. You will pay to us any agreed charges
    for delivering or collecting equipment. Where we quote carriage charges,
    these include only for the time required to load or unload alongside or
    vehicle at the address you have specified. You will pay extra for any
    further time or attendance including any attempt by us to carry out your
    pre-arranged instructions for delivery or collection which is unsuccessful
    due to your acts or omissions
  </p>
  <p>
    <strong
      >4. Maximum Period of Agreement (If you are not incorporated)</strong
    >
  </p>
  <p>
    If you are an individual or a partnership, or an unincorporated body of
    persons, the Contract will terminate not later than three months from the
    beginning of the period of hire. In such circumstances you must restore the
    Equipment to us before close of business on the day before the end of the
    three month period. If you fail to do this we will be entitled to charge you
    for any financial loss this causes us.
  </p>
  <p><strong>5. When the Contract Comes into being</strong></p>
  <p>
    The Contact comes into being when you have placed an order giving details of
    your requirements and have agreed to be bound by these conditions and we
    have accepted your order
  </p>
  <p><strong>6. Safety and Instructions</strong></p>
  <p>
    It is your responsibility to make sure that all people who use the Equipment
    are properly instructed in its safe and correct use and they are in
    possession of all instructions supplied by us. You must ensure that the
    Equipment is not misused.
  </p>
  <p>
    <strong
      >7. When Your Signature for Receipt of Equipment Becomes Effective</strong
    >
  </p>
  <p>
    Where for administrative convenience you or your agent are requested by us
    to sign a receipt for the Equipment before it is handed over, you or your
    agent will be given the opportunity to examine the Equipment when it is
    physically handed over to you or your agent. The receipt will not be
    effective until immediately after the physical handover.
  </p>
  <p><strong>8. Responsibility of hire (Your Responsibility)</strong></p>
  <p>
    8.1 You will be responsible for the loading and unloading of the Equipment
    at the address specified by you. You will also be responsible for the
    loading and unloading of the equipment at our premises when the Equipment is
    transported by you or your agent. If we supply any person to assist you,
    they will be under your control at such times.
  </p>
  <p>
    8.2 Your responsibility for the Equipment begins when you or your agent
    receive the Equipment. If it is delivered to you your responsibility begins
    on delivery. Your responsibilities include safekeeping of the Equipment and
    protection against the elements, theft, vandalism or improper use. You are
    responsible for the return of the Equipment or making clear arrangements
    with us for the collection of the Equipment at the end of the hire. Your
    responsibility ends only when the Equipment has be returned or collected and
    you have our unqualified receipt for all of the Equipment. You must not sell
    or otherwise part with control of the Equipment.
  </p>
  <p>
    8.3 You will indemnify us against any and every expense, liability,
    financial loss, claim or proceedings whatsoever, and in respect of any death
    or personal injury whatsoever or damage to or loss of property whatsoever
    (other than the Equipment itself, which is governed by Conditions 13 and 14)
    arising out of the delivery, use, mis-use with particular reference to
    Condition 6 hereof, non-use repossession, collection or return of the
    Equipment or any part of it. This indemnity will be reduced in proportion to
    the extent that such expense, liability, financial loss, claim or
    proceedings or death or personal injury or damage to or loss of property is
    due to our proven negligence.
  </p>
  <p><strong>9. Electrical Equipment</strong></p>
  <p>
    Where any part of the Equipment is electrical it should normally be used
    with plugs and/or sockets as fitted but if temporarily fitted with other
    suitable plugs or sockets, this must be carried out by a competent person
    who must also return it to its original condition. It will be your
    responsibility at all times to arrange a suitable supply of electricity for
    use with the Equipment. Under no circumstances should electrical Equipment
    be used without it being correctly earthed unless it is of double insulated
    specification. You will be responsible for complying with the requirements
    of all relevant electricity regulations and standards during the period of
    your responsibility for the Equipment as defined in Condition 8.2 of the
    Conditions.
  </p>
  <p>
    <strong
      >10. Maintenance of Equipment, Breakdown Procedures and Accident
      Reporting</strong
    >
  </p>
  <p>
    You must keep yourself acquainted with the state and condition of the
    Equipment and ensure that it remains safe, serviceable and clean. Any
    breakdown or any unsatisfactory working of the Equipment must be immediately
    notified to us. Under no circumstances must you repair or attempt to repair
    the Equipment unless authorised by us. The Equipment must be returned to our
    premises for examination except where examination elsewhere has been
    mutually agreed upon. You must notify us immediately if the Equipment is
    involved in any accident resulting in damage to the Equipment or to other
    property, or injury to any person.
  </p>
  <p><strong>11. Location of Equipment</strong></p>
  <p>
    Equipment must not be removed without our authority from any site originally
    specified by you or from any site we subsequently authorise.
  </p>
  <p><strong>12. Limits of Our Liability</strong></p>
  <p>
    12.1 All times which we state or quote for delivery or collection are
    approximate
  </p>
  <p>
    12.2 We will not be liable for any delays caused by any circumstances beyond
    our reasonable control.
  </p>
  <p>
    12.3 We will not be liable for any indirect loss, loss of business, profits,
    savings you expected to make, wasted money, wages, fees or expenses, due to
    late delivery, non-delivery, unsuitability, breakdown or stoppage of the
    equipment or any part of it.
  </p>
  <p>
    12.4 Goods are hired subject to them being available for hire to the
    Customer at the time required by the Customer. We will not be liable for any
    loss suffered by the Customer as a result of the Hire Goods being
    unavailable for hire where the Hire Goods are unavailable due to
    circumstances beyond our control.
  </p>
  <p>
    <strong
      >13. Insurance and Your Responsibility for Lost, Stolen or Damaged
      Equipment</strong
    >
  </p>
  <p>
    You will pay to us the replacement cost of any Equipment which is lost or
    stolen or damaged beyond economic repair. You are advised to insure the
    Equipment on this basis. You will hold in trust for us and pay to us on
    demand all money you receive from an insurance company or from any other
    source in settlement of any claim relating to the loss, theft or damage of
    any of the Equipment. You must not compromise any claim without our express
    consent.
  </p>
  <p>
    <strong
      >14. Non-Returned, Lost, Stolen, Damaged or Unclean Equipment</strong
    >
  </p>
  <p>
    14.1 You have full responsibility for the care and safekeeping and return in
    good order of the Equipment.
  </p>
  <p>
    14.2 You will pay to us all costs we incur in rectifying any Equipment
    returned damaged or unclean. Additionally you will pay for our financial
    loss until such rectification is complete.
  </p>
  <p>
    14.3 Where Equipment is lost or stolen or damaged beyond economic repair,
    you will pay for all financial loss to us until you have paid to us the
    replacement cost. This is without prejudice to our other rights.
  </p>
  <p><strong>15. Termination of Hire</strong></p>
  <p>
    We will be entitled at any time if you break this Contract or if any
    proceedings are commenced in which your solvency is called into question to
    terminate this Contract with immediate effect and to repossess any or all of
    the Equipment. Such termination will not affect our right to recover from
    you any money due to us under this Contract or damages for breach of
    contract.
  </p>
  <p><strong>16. Our Rights of Access</strong></p>
  <p>
    You authorise us to enter any land or premises where we reasonable believe
    any Equipment to be, in order to inspect, repair, replace or repossess it.
  </p>
  <p><strong>17. Rights Reserved</strong></p>
  <p>
    Any failure by us to enforce any or all of these Conditions shall not amount
    to, or be interpreted as, a waiver of any of our rights.
  </p>
  <p><strong>18. Separate Term Validity and Headings</strong></p>
  <p>
    If any term in this Contract is held invalid this shall not affect the
    validity of the remaining terms. The headings in these conditions are for
    reference purposes only and shall not affect the interpretation of these
    conditions.
  </p>
  <h1><strong>General Conditions of Sale</strong></h1>
  <p>1. Definitions and Law</p>
  <p>
    The Contract is the document or documents that set out these Conditions and
    all other details about your agreement with us. "We" and "Us" means the
    seller of the Goods. "You" means the buyer of the Goods. The "Goods" means
    all goods to be sold by us to you. The "Recipient" means the person, firm,
    Company, corporation or public authority to whom the Goods are delivered,
    when it is not you. These Conditions exclude any terms and conditions you
    may have put forward, except where we have agreed to any amendments or other
    conditions in writing. These Conditions do not affect the statutory rights
    of a person dealing as a consumer as defined by the Unfair Contract Terms
    Act 1977 or any statutory modification of them. The Contact will be governed
    by and interpreted in accordance with the laws of {{ country }}
  </p>
  <p>2. Pricing</p>
  <p>
    All prices, displayed in any format, are exclusive of VAT. VAT is charged at
    the standard rate applicable in {{ country }}. We reserve the right to amend
    pricing without notice.
  </p>
  <p>3. When the Contract Comes Into Being</p>
  <p>
    The Contract comes into being when you have placed an order giving details
    of your requirements and have agreed to be bound by these Conditions and we
    have accepted your order.
  </p>
  <p>4. Cancellation Policy</p>
  <p>
    We require 7 days cancellation notice prior to scheduled delivery of goods
    and/or services. You may cancel by contacting the customer service team. In
    the case of cancellation without notice, we reserve the right to charge a
    cancellation fee equal to any reasonable financial loss incurred for the
    preparation and delivery of goods. Refunds for online purchases will be
    subject to a reduction of 3% to cover admin and payment processing charges
    incurred by the company.
  </p>
  <p>5. Payment</p>
  <p>
    Where we have granted monthly account facilities to you in writing, all
    invoices must be paid by the last day of the month following the month of
    delivery. Where no such facilities have been granted, payment will be with
    your order, or where previously agreed, on delivery. If payment is not made
    when due, we will be entitled to interest on the amount that is overdue at
    [5%] five percent above the prevailing base rate of Ulster Bank Ltd
    calculated on a daily basis. This will be without prejudice to any other
    rights or remedies we might have. Refunds for online purchases will be
    subject to a reduction of 3% to cover admin and payment processing charges
    incurred by the company.
  </p>
  <p>6. Receipt</p>
  <p>
    You, or the Recipient on your behalf, will receive and unload the Goods and
    should check the quantity and condition in the presence of the carrier. If
    there is a shortage or if any of the Goods are in an unsatisfactory
    condition, you or the Recipient must so endorse the carrier’s delivery
    document and must give a separate written notice of this to us within 3
    working days of delivery. If this Condition is not observed, no claim in
    respect of shortage or unsatisfactory condition of the Goods will be
    entertained.
  </p>
  <p>7. Risk and Title of Goods</p>
  <p>
    7.1 The risk in the Goods will pass to you immediately on delivery of the
    Goods to you or to the Recipient.
  </p>
  <p>
    7.2 The ownership of the Goods will remain with us, and we reserve the right
    to dispose of the Goods , until you have paid in full for all Goods which we
    have supplied at any time to you and you have a paid all debts due to us.
    Until such payment has been made in full you will hold the Goods on our
    behalf and to our order and you will be under an obligation to return the
    Goods to us on demand. Upon any breach by you or any of the terms in this
    Contract, or upon you insolvency or presentation to Court of a Petition for
    your Liquidation or for appointment of a Liquidator, Receiver or examiner,
    or presentation of a Petition for your Bankruptcy, we will be entitled to
    rescind or terminate this Contract and immediately to repossess the Goods.
    You will permit us to enter any land or premises owned, used or occupied by
    you in order to recover our Goods, and you permit us to open shut and lock
    fast places for the purpose of finding or recovering our Goods.
  </p>
  <p>8. Limit of Our Liability</p>
  <p>8.1 All times which we state or quote for delivery are approximate.</p>
  <p>
    8.2 We will not be liable for any delays caused by any circumstances beyond
    our reasonable control.
  </p>
  <p>
    8.3 We will not be liable for any indirect loss, loss of business, profits,
    savings you expected to make, wasted money, wages, fees or expenses, due to
    late deliver, non-delivery, unsuitability, breakdown or stoppage of the
    Goods or any part of them.
  </p>
  <p>9. Rights Reserved</p>
  <p>
    Any failure by us to enforce any or all of these Conditions shall not amount
    to or be interpreted as a waiver of any of our rights
  </p>
  <p>10. Separate Terms Validity and Headings</p>
  <p>
    If any term in this Contract is held invalid, this shall not affect the
    validity of the remaining terms. The headings in these Conditions are for
    reference purposes only and shall not affect the interpretation of these
    Conditions.
  </p>
  <p>11. Privacy Policy</p>
  <p>
    Our Privacy Policy sets out the terms by which we process any personal data
    we collect from you or that you provide to us and your rights under Data
    Protection Acts and GDPR. By using our website and/or by availing of our
    services, you consent to such processing and you warrant that all data
    provided to us is accurate.
  </p>
</div>

<mat-dialog-actions align="end">
  <button mat-flat-button [matDialogClose]="true">Close</button>
</mat-dialog-actions>
